import Swiper from "swiper";

export class ShippingSteps {
  private readonly swiperDiv: HTMLDivElement;
  private readonly swiper: Swiper;

  constructor(swiperDiv: HTMLDivElement) {
    this.swiperDiv = swiperDiv;
    this.swiper = new Swiper(this.swiperDiv, params);
  }
}

const params = {
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  loop: true,
  pagination: {
    clickable: true,
    el: ".swiper-pagination",
    renderBullet(index, className) {
      let spanclass = "";
      switch (index) {
        case 0:
          spanclass = "svg-icon-mail ";
          break;
        case 1:
          spanclass = "svg-icon-lkw ";
          break;
        case 2:
          spanclass = "svg-icon-home ";
          break;
        case 3:
          spanclass = "svg-icon-30 ";
          break;
      }

      return '<span class="' + spanclass + className + " " + spanclass + '"></span>';
    },
    type: "bullets",
  },
  preloadImages: false,
  simulateTouch: false,
};
